// extracted by mini-css-extract-plugin
export default {"icon":"styles_icon__hrsJP","icon_left":"styles_icon_left__1HcMB","icon_placeholder":"styles_icon_placeholder__10BFz"};